// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3865":"4638c5a7","7230":"5c9dd72c"}[chunkId] + ".chunk.css";
};